import Api from "./Api";

class PreliminaryReportApi extends Api {
  getList(data: object) {
    const url = this.prepareUrl(
      "/disclosurecode/private/preliminaryreport/getlist"
    );
    return this.requestGetList(url, data);
  }

  get(id: number | undefined | string = undefined, data: object = {}) {
    const url = this.prepareUrl(
      "/disclosurecode/private/preliminaryreport/",
      id
    );
    return this.requestGet(url, data, "object");
  }

  unlock(id: number) {
    const url = this.prepareUrl(
      "/disclosurecode/private/preliminaryreport/unlock/",
      id
    );
    return this.requestGet(url, {});
  }

  getReportUrl() {
    const url = `${this.url}/disclosurecode/private/preliminaryreport/`;
    return url;
  }

  getStatus() {
    const url = `${this.url}/disclosurecode/private/preliminaryreport/status/`;
    return this.requestGet(url, {}, "object");
  }

  getSummary(year?: number): any {
    const url = this.prepareUrl(`/disclosurecode/private/summary/`, year);
    return this.requestGet(url, {}, "object");
  }
}

export default new PreliminaryReportApi();
